<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">BSAC Japan eラーニングについて</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <h4 class="page-content__article-section-title">■ BSAC Japan eラーニングで出来ること</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              当eラーニングでは、BSAC
              Japanが提供しているダイビングの各コースのセオリーレッスン（学科講習）を、ご自身のデジタルデバイスを使用して受講する事が出来ます。これにより、皆様のお好きな時間に、お好きな場所で、ご自身のペースでコースの受講を進める事が可能になります。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ BSAC Japan eラーニングの概要</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              インターネットにつながる環境で、PC、タブレット等を用いて申込手続きと必要な代金の支払いを済ませ、
              BSAC
              Japanが提供している各コースのセオリーレッスン（学科講習）の部分を、ご自宅のデジタルデバイス（PC、タブレット等）を活用して受講する事が出来ます。ただし、海での実習など、必要な項目を省略する事は出来ません。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ 受講手順</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                BSAC Japan eラーニング受講可能店舗一覧から、受講する店舗を確認して選択する。<br />
                （フリーメンバーからの受講を希望される場合は、事前にインストラクターに受講可能か確認しておく。）
              </li>
              <li>
                本サイトよりコース申込、受講了解事項の承認、健康チェックを済ませ、必要な費用の支払いを完了する。
              </li>
              <li>BSAC JAPANからIDとパスワードが送られて来るのを待つ。</li>
              <li>
                送られてきたIDとパスワードを使用して受講サイトからログインをし、受講を開始する。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ 受講前の注意点</h4>
          <div class="page-content__article-section-body">
            <ul>
              <li>
                年齢制限について
                <p>
                  各種コースには、定められた年齢制限があります。コースを申し込む前に必ずダイブセンターやインストラクターに確認してください。またコース受講に必要な年齢に達していても、明らかに受講ができないとインストラクターが判断した場合、受講をお断りする場合がございます。<br />
                  例）サイズなどが合うダイビング器材が無い場合など
                </p>
              </li>
              <li>
                未成年者の受講について
                <p>
                  未成年の方のコース受講については、必ず親権者の承諾をもらい、所定の申込書にご本人と親権者のご署名をお願いいたします。
                </p>
              </li>
              <li>
                受講期限
                <p>
                  受講期限は、利用開始の翌日から6ヵ月となっております。この受講期限は延長することはできません。
                </p>
              </li>
              <li>
                代金の支払いについて
                <p>
                  当 eラーニングを受講する場合、セオリーレッスン（学科講習）の費用はBSAC
                  Japanに、残りの費用（プール実習、海洋実習等）はダイブセンターにお支払い頂きます。残りの費用については、必ず事前にダイブセンターやインストラクターに確認してください。
                </p>
              </li>
              <li>
                受講のキャンセルについて
                <p>
                  受講のキャンセルについては、利用開始から8日以内にBSAC
                  Japanにその旨ご連絡ください。当eラーニングの利用が、一つのChapterを終えていない場合、振り込み手数料を除いた金額を返金いたします。ただし、法人での利用※申込の場合は、返金できませんのでご了承の程よろしくお願いいたします。<br />
                  ※企業や団体で複数人の申込をされた場合
                </p>
              </li>
              <li>
                教材について
                <p>
                  学習に必要な教材については、当eラーニングの中に参考資料を掲載しています。各種コースのマニュアルは販売もしていますので、ダイブセンターやインストラクターにご相談してください。
                </p>
              </li>
              <li>
                複数名の受講について
                <p>
                  当eラーニングでは、1つのアカウントで複数名の受講は認めていません。コースを修了しても、申込者の名前で修了証が発行されますので、必ず１アカウントで1名の受講をお願いいたします。
                </p>
              </li>
              <li>
                BSAC Japan eラーニング受講可能店舗以外での受講
                <p>
                  BSACダイブセンターやインストラクターには、eラーニング受講の対応をしていないダイブセンターやインストラクターがいますので、受講可能店舗やインストラクター以外でコースの受講を進める事はできません。
                </p>
              </li>
              <li>
                修了証について
                <p>
                  コースによっては、eラーニングを全て修了して、「修了証」を提出しないと次の講習に進めない場合があるので、必ずダイブセンターやインストラクターに事前に確認してください。
                </p>
              </li>
              <li>
                対応のブラウザやOSの一覧
                <p>
                  当eラーニングは、Google Chrome、Microsoft Edge、Apple
                  Safariのブラウザでのみ動作確認をしております。
                </p>
              </li>
              <li>
                また、次のページに記載のある「BSAC Japan
                eラーニングサービス利用規約」も内容をご確認ください。
              </li>
            </ul>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ パソコンでのご利用</h4>
          <div class="page-content__article-section-body--noindent">
            <p>
              OS： Windows 11<br />
              ブラウザ： Microsoft Edge、Google Chrome いずれも最新<br />
              プラグイン：Adobe Acrobat Reader　最新<br />
              最新 メモリ： 8 GB 以上<br />
              解像度： 1024 x 768 pixel 以上<br />
            </p>
            <ul class="page-content__ul-aster-ja">
              <li class="page-content__li-aster-ja">
                最新のWindows Updateを適用のうえ、ご利用ください。
              </li>
            </ul>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">
            ■ スマートフォン・タブレットでのご利用
          </h4>
          <div class="page-content__article-section-body--noindent">
            <p>
              モバイル対応サービスは、スマートフォン・タブレットでのご利用が可能です。<br />
              OS × ブラウザ：<br />
              iOS、iPad OS　×　Safari　いずれも最新<br />
              Android　×　Google Chrome　いずれも最新<br />
            </p>
            <ul class="page-content__ul-aster-ja">
              <li class="page-content__li-aster-ja">
                モバイル対応サービスをご利用中にモバイル端末でアクセスすると、パネル表示のモバイルマイルームが開きます。パソコン用表示と併用のご契約をされている場合は、
                マイルームトップ画面にて「PC／モバイル」の表示を切り替えることができます。
              </li>
              <li class="page-content__li-aster-ja">
                一部のeラーニングコースはモバイルに対応しておりません。パソコンにてご受講ください。
              </li>
              <li class="page-content__li-aster-ja">
                修了証書発行コースやダウンロード資料があるコースはPDF閲覧ソフトが必要です。
              </li>
              <li class="page-content__li-aster-ja">
                すべての端末での動作を保証するものではありません。あらかじめご了承ください。
              </li>
            </ul>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ 通信速度</h4>
          <div class="page-content__article-section-body--noindent">
            <p>ブロードバンド環境推奨</p>
            <ul class="page-content__ul-aster-ja">
              <li class="page-content__li-aster-ja">下り 1.5 Mbps 以上を推奨いたします。</li>
              <li class="page-content__li-aster-ja">
                動画を使用したコースの通信速度は、下り 10 Mbps 以上を推奨いたします。
              </li>
            </ul>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">■ その他</h4>
          <div class="page-content__article-section-body">
            <ul>
              <li>
                音声出力
                <p>
                  音声デバイス（スピーカー、イヤホンなど）が接続されてないPCではコース上の動画・音声が再生されない場合がございます。受講の際には音声デバイスのご用意をお願いいたします。
                </p>
              </li>
              <li>
                クッキー（Cookie）の有効化
                <p>
                  当社のeラーニングサービスでは、ログイン後の接続状態の保持に必要な情報の管理（セッション管理）に、クッキー（Cookie）を使用しています。ご利用のブラウザの設定でクッキーが使用できない状態になっているとeラーニングサービスへのログインができませんので、クッキーを受け入れるように設定してください。
                </p>
              </li>
              <li>
                Javaスクリプトの有効化
                <p>
                  当社のeラーニングサービスでは、よりよいｅラーニングサービスのために、Javaスクリプトを使用しています。当社のeラーニングサービスの機能をご利用いただくために、ブラウザの設定画面で、Javaスクリプトを「有効にする」に設定してください。
                </p>
              </li>
              <li>
                TLS1.2暗号化通信対応環境
                <p>「TLS1.2」対応の端末やブラウザをご利用くださいますようお願いいたします。</p>
              </li>
            </ul>
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <button
            id="nextButton"
            v-show="isShowDialogButton"
            @click="showDialog"
            class="btn btn-danger rounded-pill"
          >
            お申し込みの前にご確認ください
          </button>
          <router-link v-show="isShowNextButton" to="/terms" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              BSAC Japan eラーニング利用規約へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="overlay" v-show="isShowDialog" class="page-content__overlay">
      <div id="content" class="page-content__overlay-contents">
        <article>
          <section>
            <h4 class="page-content__article-section-title--dialog-red">
              【ご注意】お申込みの前に！
            </h4>
            <div class="page-content__article-section-body--dialog-message">
              <p>
                BSAC Japan eラーニングの費用はBSAC
                Japanにお支払い頂き、それ以降の実技講習についてはダイブセンターもしくはインストラクターに
                別途お支払い頂くシステムとなっております。<br />
                その為、必ず事前にeラーニング受講可能店かインストラクターから説明を受けてからお申込み下さい。
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <p><button class="btn btn-danger rounded-pill" @click="closeDialog">閉じる</button></p>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowDialogButton: true,
      isShowNextButton: false,
      isShowDialog: false,
    };
  },
  methods: {
    /**
     *
     */
    showDialog: function () {
      this.isShowDialogButton = false;
      this.isShowDialog = true;
    },
    closeDialog: function () {
      this.isShowNextButton = true;
      this.isShowDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';
</style>
